let module = {};

/**
 * Container Initialization
 */
module.init = function () {
    let heroContainer = document.querySelector('.hero-with-background');
    let ratingContainer = document.querySelector('.uag-star-rating');
    let locationDetails = document.querySelector('#location-details');
    let offerings = document.querySelector('#offerings');
    let seoContainer = document.querySelector('#seo-content');
    let faq1 = document.querySelector('#faq1');
    let faq2 = document.querySelector('#faq2');
    let benefits = document.querySelector('#benefits');

    let hideQuerySelector = ( element ) => {
        if ( element ){
            let elementToHide = document.querySelector(element);
            if ( elementToHide) {
                elementToHide.remove();
            }
        }
    }

    let getDecimalPart = (number) => {
        // Convert the number to a string
        const numberAsString = number.toString();

        // Split the string using the decimal point as a delimiter
        const parts = numberAsString.split('.');
        // Check if there is a decimal part
        if (parts.length === 2) {
            // Return the decimal part as a number
            let number = parseFloat(`0.${parts[1]}`);
            return parseFloat(number.toFixed(1));
        } else {
            // If there is no decimal part, return 0
            return 0;
        }
    }

    // customize display
    // we know this is all bad
    // but we can't access these values server side

    // BEGIN HERO IMAGE CUSTOMIZATION
    // if they added a hero image in MPG, show it
    // otherwise show our default
    if ( heroImage ) {
        heroContainer.style.backgroundImage = 'url("' + heroImage +'")';
    } else {
        heroContainer.style.backgroundImage = 'url("/wp-content/themes/erie-child/dist/images/hero-locations.jpg")';
    }
    // END HERO IMAGE CUSTOMIZATION


    // BEGIN CUSTOM RATINGS
    if ( rating && ratingContainer ){
        let roundedUpScore = Math.ceil(rating);
        let blanks = 5 - roundedUpScore;
        let decimalPart = getDecimalPart(rating);
        let decimalClass = decimalPart.toString().replace(/\./g, '-');
        let starHTML = '';
        let ratingTitle = document.querySelector('.uag-star-rating__title');

        // iterate our rating full stars
        for (let i = 0; i < Math.floor(rating); i++) {
            starHTML += '<span class="uag-star uag-star--red">★</span>';
        }

        // check for a float and add half star if necessary
        if (rating % 1 !== 0) {
            starHTML += '<span class="uag-star uag-star--part uag-star--' + decimalClass + '">★</span>';
        }

        // check for empty stars
        for (let j = 0; j < blanks; j++) {
            starHTML += '<span class="uag-star uag-star--blank">★</span>';
        }

        ratingContainer.setAttribute('title', rating + '/5');
        ratingContainer.innerHTML = starHTML;
        if ( ratingTitle ){
            ratingTitle.textContent = rating;
        }
    }
    // END CUSTOM RATINGS


    // BEGIN SERVICE AREA CUSTOMIZATION
    // if this isn't a service area, hide our h5 in our hero
    // also hide h3 in our contact form
    if ( locationDetails ) {
        if ( isServiceArea && isServiceArea.toLowerCase() === "false" || ( officeCity === city && officeState === state) ){

            let contactContainer = document.querySelector('#contact-locations');
            let contactServiceArea = contactContainer.querySelector('.lead-gen__kicker');

            if (contactServiceArea) {
                contactServiceArea.remove();
            }
        }

        if (officeCity !== city || officeState !== state) {
            const serviceAreaKicker = heroContainer.querySelector('.mpg__service-area');
            serviceAreaKicker.classList.add('visible');
        }
    }

    const serviceAreaWrapper = heroContainer.querySelector('.mpg__service-area-wrapper');
    if (serviceAreaWrapper) {
        serviceAreaWrapper.classList.add('visible');
    }

    // END SERVICE AREA CUSTOMIZATION


    // BEGIN SERVICES CUSTOMIZATION
    // TODO - see about refactoring block to handle json instead
    if ( offerings ){
        if ( !serviceMetalRoofing.trim() ){
            hideQuerySelector('#metal-roofing'); // TODO enhance by getting this list from mpg
        } else {
            // check to see if we have an image for the service
             if ( metalImage ) {
                let imageElement = document.getElementById('metal-roofing');
                imageElement.setAttribute('data-img', metalImage);
            }
        }
        if ( !serviceAsphaltShingle.trim() ){
            hideQuerySelector('#asphalt-shingles');
        } else {
            // check to see if we have an image for the service
             if ( asphaltImage ) {
                let imageElement = document.getElementById('asphalt-shingles');
                imageElement.setAttribute('data-img', asphaltImage);
            }
        }
        if (!serviceWaterproofing.trim()) {
            hideQuerySelector('#waterproofing');
        } else {
            // check to see if we have an image for the service
             if ( waterproofingImage ) {
                let imageElement = document.getElementById('waterproofing');
                imageElement.setAttribute('data-img', waterproofingImage);
            }
        }
        if ( !serviceFoundation.trim() ){
            hideQuerySelector('#foundation-repair');
        } else {
            // check to see if we have an image for the service
             if ( foundationImage ) {
                let imageElement = document.getElementById('foundation-repair');
                imageElement.setAttribute('data-img', foundationImage);
            }
        }
        if ( !serviceAirQuality.trim() ){
            hideQuerySelector('#air-quality');
        } else {
            // check to see if we have an image for the service
             if ( airImage ) {
                let imageElement = document.getElementById('air-quality');
                imageElement.setAttribute('data-img', airImage);
            }
        }

        // Set the initial image to the image associated with the first drawer
        initAccordion(); // function in our accordion js
        // open the first drawer
        let firstItem = document.querySelector('.accordion-with-image__drawer');
        if (firstItem) {
            firstItem.classList.remove('accordion-with-image__drawer--closed');
        }
    }
    // END SERVICES CUSTOMIZATION


    // BEGIN YOUTUBE VIDEO DISPLAY
    if ( !videoId){
        let videoContainer = document.querySelector('.mpg-youtube-video');
        if ( videoContainer ){
            videoContainer.innerHTML = '<img src="/wp-content/themes/erie-child/dist/images/placeholder.png" alt="Erie Home logo" />';
        }
    }
    // END YOUTUBE VIDEO DISPLAY

    // BEGIN SEO CONTENT CUSTOMIZATION
    if ( seoContainer ){
        let seoContent = seoContainer.querySelector('#mpg-seo-content');
        if ( seoContent.textContent.trim() === '' ) {
            seoContainer.remove();
        }
    }
    // END SEO CONTENT CUSTOMIZATION


    // BEGIN FAQ CONTENT CUSTOMIZATION
    if ( faq1 ){
        let faq1Content = faq1.querySelector('.uagb-question');
        if ( faq1Content.textContent.trim() === '' ) {
            faq1.remove();
        }
    }
    if ( faq2 ){
        let faq2Content = faq2.querySelector('.uagb-question');
        if ( faq2Content.textContent.trim() === '' ) {
            faq2.remove();
        }
    }
    // END FAQ CONTENT CUSTOMIZATION

    // BEGIN BENEFITS
    if ( benefits ){
        for (let i = 1; i <= 6; i++) {
            let currentBenefit = document.querySelector('#benefit' + i);
            if ( currentBenefit ){
                let benefitHeading = currentBenefit.querySelector('h4');
                let benefitCopy = currentBenefit.querySelector('p')
                if ( benefitHeading.textContent.trim() === '' && benefitCopy.textContent.trim() === '') {
                    currentBenefit.remove();
                }
            }
        }
    }
    // BEGIN BENEFITS
};

document.addEventListener("DOMContentLoaded", () => {
	module.init();
});

